module.exports = __webpack_public_path__ + "static/media/resume.097a9e89.pdf";